let common = {
    error: '应用不存在，请检查应用链接是否正确',
    code501: '访问权限限制',
    success:"操作成功！",
    failed: "操作失败！",
    addSuccess: "添加成功！",
    updateSuccess: "修改成功！",
    deleteSuccess: "删除成功！",
    exportSuccess: "导出成功！",
    addFailed: "添加失败！",
    updateFailed: "更新失败！",
    deleteFailed: "删除失败！",
    spin: {
        text: '加载中...',
    },
    push: {
        text: '推送',
        sendCode: '发送验证码',
    },
    code: {
        verifyCode: '验证码',
        get: '获取验证码',
        msg6: '请输入6位数字的验证码',
        enterCode: '请输入验证码',
    },
    btn: {
        submit: '确定',
        search: '查询',
        reset: '重置',
        default: '恢复默认',
        add: '添加',
        edit: '修改',
        update: '更新',
        delete: '删除',
        deleteAll: "删除全部",
        batchDelete: '批量删除',
        save: '保存',
        cancel: '取消',
        back: '返回',
        close: '关闭',
        loading: '加载中.....',
        commit: '提交',
        lock: '锁定',
        unlock: '解锁',
        bind: '绑定',
        unbind: '解绑',
        upload: '上传',
        export: '导出',
    },
    operation: '操作',
    lock: {
        lockStatus: '锁定状态',
        locked: '已锁定',
        unlocked: '未锁定',
        confirmLockCheckedData: '您确定要锁定{name}吗？',
        confirmUnlockCheckedData: '您确定要解锁{name}吗？',
    },
    pwd: {
        password: '密码',
        enterPassword: '请输入密码',
        confirmPassword: '确认密码',
        enterConfirmPassword: '请输入确认密码',
        oldPassword: '旧密码',
        enterOldPassword: '请输入旧密码',
        newPassword: '新密码',
        enterNewPassword: '请输入新密码',
        passwordNotMatch: '两次输入的密码不一致',
        passwordInvalid: '密码长度6~24'
    },
    browser: {
        errorAuthentication: '您的浏览器暂不支持此认证方式！',
        arouse: '已经唤起认证器！',
        overtime: '用户取消操作或操作超时！',
        noWeb: '这个浏览嚣不支持Web认证！',
        secureConnection: 'Web认证仅支持安全连接',
        authenticationMethod: '请选择认证方式！',
        FIDO2Look: 'FIDO2认证登录失败：认证器已锁定',
        FIDO2Err: 'FIDO2认证登录失败：认证器未启用',
        nonsupport: '您的浏览器暂不支持绑定令牌！',
    },
    pagination: {
        from: '从',
        to: '到',
        aggregate: '总计',
        strip: '条',
        perPage: '每页数目',
    },
    tailorImg: {
        title: '头像上传',
        uploadText: '选择图片',
        typeErr: '请上传JPG、PNG图片!',
        sizeErr: '图片不能大于200kb!',
        noFile: '请选择图片！',
    },
    header: {
        goOut: '退出登录',
        modalTitle: '会话即将超时提醒',
        okText: '继续使用',
        countdown: '当前剩余会话时长',
        notification: '消息通知',
        tip1: '您有',
        tip2: '条消息未查看',
    },
        status: "状态",
    normal: "正常",
    notActive: "未激活",
    createTime: "创建时间",
    descp: "描述",
    descpMaxLength: "描述长度最大为255个字符",
    noSpacesAllowedBothEnds: "两端不允许有空格",
    nameFormat: "名称长度1-64，支持汉字、字母、数字、空格、_-",
    nameFormat32: "名称长度1-32，支持汉字、字母、数字、空格、_-",
    selFile: "选择文件",
    uploadFile: "上传文件",
    clickOrDragFile: "点击或拖拽文件到此处",
    fileIsEmpty: "请上传文件",
    fileName: "文件名",
    fileSize: "文件大小",
    fileTypeUnsupported: "文件格式不支持，请上传{type}",
    fileTooLarge: "文件大小超出限制，最大只能{size}",
    none: "无",
    selType: "请选择类型",
    confirmDeleteCheckedData: "确认删除{name}？",
    confirmUnbindCheckedData: '确定要解绑{name}？',
    cancelRelease: "确定要取消任务{name}？",
    settings:{
		session_expire_time: "登录会话有效期",
		login_failed_limit: "登录失败最大重试次数",
		account_lock_time: "登录失败超限锁定时间",
		session_30m: "30分钟",
		session_60m: "60分钟",
		session_120m: "2小时",
		session_12h: "12小时",
		session_24h: "24小时",
		lock_10m: "10分钟",
		lock_30m: "30分钟",
		lock_60m: "1小时",
		lock_120m: "2小时",
		lock_12h: "12小时",
		lock_24h: "24小时"
	}

}

export default common
